/** @jsxImportSource @emotion/react */
import React from 'react';
import { View, Text, StyleSheet } from 'react-native';

import Fonts from 'Themes/fonts';

import EditableProductsListComponent from './EditableProductsListComponent';

function EditableProductList({ products = [] }) {
    if (!products.length) {
        return (
            <View style={{ marginTop: 10 }}>
                <Text style={styles.noCartMessage}>
                    You do not have any items in the cart now. Add some now!
                </Text>
            </View>
        );
    }

    return (
        <div>
            {products.map((product) => (
                <EditableProductsListComponent key={product.selectedVariant.sku} product={product} />
            ))}
        </div>
    );
}

const styles = StyleSheet.create({
    noCartMessage: {
        fontFamily: Fonts.primary,
        fontSize: 15,
    },
});

export default EditableProductList;
